export default __webpack_public_path__ + "static/media/Rishabh.87f511be.jpg";